import React, { useEffect } from 'react';
import { useTable, useRowSelect } from 'react-table';
import TableWrapper from './style';
import CheckBox from 'reusecore/src/elements/Checkbox';

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <CheckBox labelText="" reference={resolvedRef} {...rest} />
      </>
    );
  }
);

export default function Table({
  columns,
  data,
  onSelect,
  getRowProps,
  ...props
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
    },
    useRowSelect,
    hooks => {
      hooks.visibleColumns.push(columns => {
        let select = {};
        if (onSelect) {
          select = {
            id: 'selection',
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <div className="hidden-mobile">
                <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
              </div>
            ),
            Cell: ({ row }) => (
              <div className="hidden-mobile">
                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
              </div>
            ),
          };
        }
        return [select, ...columns];
      });
    }
  );
  useEffect(() => {
    const ids = selectedFlatRows.map(row => row.original.key);
    onSelect(ids);
  }, [selectedFlatRows]);
  const tableProps = { ...getTableProps(), ...props };
  if (onSelect) {
    tableProps.className += ' has-selector';
  }
  return (
    <TableWrapper {...tableProps}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>
                <div className="cell">{column.render('Header')}</div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          const rowProps = getRowProps ? getRowProps(row, i) : {};
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => (
                <td {...cell.getCellProps()}>
                  <div className="cell">{cell.render('Cell')}</div>
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </TableWrapper>
  );
}
